import API from "@/services/api/api.service";
import { TherapyTrend, TherapyStatistics, TherapiesStatisticsRangeType } from "@/utils/models/therapy.model";
import dayjs from "dayjs";
import { RouteLocationNormalized } from "vue-router";

export const therapyTrendResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getTherapyTrend({ patient_id: to.params.id as string, therapy_id: to.params.therapy_id as string | undefined, range_type: to.query.range as TherapiesStatisticsRangeType | undefined, date_from: to.query.from as string, date_to: to.query.to as string });
        to.meta.therapy = res.data.data;
    } catch (error) {
        console.error('THERAPY_RESOLVER_ERROR');
        return { to: `/patient/${to.params.id}` };
    }
}